import type { PreviewDevLoopState } from '../workspace/preview-state';
import { Button } from './ui/button';

export function PreviewDevLoopBanner({
  state,
  onPrimary,
}: {
  state: PreviewDevLoopState;
  onPrimary: () => void;
}): React.JSX.Element {
  return (
    <div
      data-testid="preview-dev-loop-banner"
      role="alert"
      className="mb-3 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-warning/30 bg-warning/10 px-4 py-2 text-sm"
    >
      <div className="flex items-center gap-2 text-warning">
        <svg
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            d="M8 1.5L14.5 13.5H1.5L8 1.5Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinejoin="round"
          />
          <path
            d="M8 6v3.5M8 11v.5"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
          />
        </svg>
        <span data-testid="preview-dev-loop-banner-message">
          {state.label}{' '}
          {state.detail && (
            <span className="font-mono text-xs text-warning/80">({state.detail})</span>
          )}
        </span>
      </div>
      <Button
        variant="secondary"
        size="sm"
        data-testid="preview-dev-loop-primary-cta"
        onClick={onPrimary}
        // hover:border-warning/40 hover:text-warning override secondary's baked
        // hover:border-white/[0.24] hover:text-white so the CTA stays on the
        // warning palette on hover (matches the old amber button).
        className="border-warning/40 bg-warning/20 text-warning hover:border-warning/40 hover:bg-warning/30 hover:text-warning"
      >
        Retry install &amp; start preview
      </Button>
    </div>
  );
}
